import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ClipboardList, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { fmtTL, fmtGram, fmtDate, STATUS_COLORS } from "@/lib/format";

export default function Orders() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-24"><Loader2 className="animate-spin text-gold" size={28} /></div>;

  return (
    <div>
      <h1 className="font-display text-3xl text-foreground mb-1">Siparişlerim</h1>
      <p className="text-sm text-muted-foreground mb-6">{orders.length} sipariş</p>

      {orders.length === 0 ? (
        <div className="text-center py-20 text-muted-foreground">
          <ClipboardList className="mx-auto mb-4" size={44} strokeWidth={1.2} />
          <p className="text-sm">Henüz sipariş vermediniz.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => (
            <button
              key={o.id}
              data-testid={`order-row-${o.order_number}`}
              onClick={() => navigate(`/orders/${o.id}`)}
              className="w-full text-left bg-surface border border-border rounded-md p-4 hover:border-gold transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-sm text-gold">{o.order_number}</span>
                <span className={`text-[11px] px-2 py-1 rounded border ${STATUS_COLORS[o.status] || ""}`}>{o.status}</span>
              </div>
              <div className="flex items-center justify-between mt-2">
                <div className="text-xs text-muted-foreground">
                  <span>{o.items.length} ürün</span>
                  <span className="mx-2 text-border">•</span>
                  <span>{fmtDate(o.created_at)}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`text-[10px] px-1.5 py-0.5 rounded border ${o.gram_finalized ? "border-emerald-500/40 text-emerald-400" : "border-amber-500/40 text-amber-400"}`}>{o.gram_finalized ? "Kesin" : "Tahmini"}</span>
                  <span className="text-foreground font-semibold text-sm">Has {o.gram_finalized ? "" : "~"}{fmtGram(o.total_has)} gr</span>
                  <ChevronRight size={16} className="text-muted-foreground" />
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
